import React from "react";
import { Heading } from "components/ui/Text";
import { ApiAdminUser } from "utils/api/admin/user";
import { formatCurrency } from "utils/string";
import { formatDateString } from "utils/date";
import * as Styled from "./styled";
import AnnualizedIncome from "./AnnualizedIncome";

interface Props {
  user: ApiAdminUser;
}

const IncomeEmployment: React.FC<Props> = ({ user }) => (
  <Styled.SectionTile>
    <Styled.Info>
      <Styled.InfoSection>
        <Heading.H4 tag="h2">Income</Heading.H4>
        <Styled.InfoItem
          label="Compensation Unit"
          value={user.payrollAccount?.compensationUnit || "n/a"}
        />
        <Styled.InfoItem
          label="Pay Frequency"
          value={user.payrollAccount?.payFrequency || "n/a"}
        />
        <Styled.InfoItem
          label="Pay Period Start Date"
          value={user.payrollAccount?.payPeriodStartDate || "n/a"}
        />
        <Styled.InfoItem
          label="Compensation Amount"
          value={
            formatCurrency(
              (user.payrollAccount?.compensationAmountInt || 0) / 100.0,
              true
            ) || "n/a"
          }
        />
        <Styled.InfoItem
          label="Annualized Compensation Amount"
          value={
            formatCurrency(user.annualizedCompensation || 0, true) || "n/a"
          }
        />
        {user.payrollAccount?.overriddenAt && (
          <Styled.InfoItem
            label="Payroll Overridden At"
            value={formatDateString(
              user.payrollAccount?.overriddenAt,
              "numericShortWithTime"
            )}
          />
        )}

        <AnnualizedIncome user={user} />
      </Styled.InfoSection>
    </Styled.Info>
  </Styled.SectionTile>
);

export default IncomeEmployment;
